"use client";
import Button from "@/common/Button";
import React from "react";
import "../Home.css";
import Image from "next/image";

import useIsMobile from "@/hooks/useIsMobile";
import { useAuth } from "@/context/AuthProvider";
import carIconYellow from "@/assets/landing/carYellow.svg";
import checkmarkYellow from "@/assets/landing/checkmarkYellow.svg";
import glitterYellow from "@/assets/landing/glitterYellow.svg";
import checkmarkDoc from "@/assets/landing/checkmarkDoc.svg";

function KaufClever() {
  const isMobile = useIsMobile();
  const { isLoggedIn } = useAuth();
  return (
    <div className="KaufClever">
      <div className="KaufClever-wrapper">
        <div className="KaufClever-top">
          <div className="KaufClever-title-wrapper">
            <h1 className="KaufClever-title">
              Kauf clever. Kauf direkt {!isMobile && <br />}von
              Privatverkäufern.
            </h1>
          </div>
          <h2 className="KaufClever-subtitle">
            Autoeinfachlos ist der neue Weg, Gebrauchtwagen direkt von
            Privatverkäufern zu kaufen – 100% online und ohne Zwischenhändler,
            die mitverdienen. Unser Expertenteam unterstützt dich dabei, deine
            Käufe schnell und unkompliziert abzuschließen.
          </h2>

          {isMobile ? (
            <Button
              maxWidth="328px"
              fontSize="16px"
              paddingHorizontal="32px"
              paddingVertical="10px"
              link={isLoggedIn ? "/marktplatz" : "/registrieren"}
            >
              {isLoggedIn ? "Zum Marktplatz" : "Jetzt Registrieren"}
            </Button>
          ) : (
            <Button
              maxWidth="328px"
              fontSize="22px"
              paddingHorizontal="32px"
              paddingVertical="16px"
              link={isLoggedIn ? "/marktplatz" : "/registrieren"}
            >
              {isLoggedIn ? "Zum Marktplatz" : "Jetzt Registrieren"}
            </Button>
          )}
        </div>

        <div className="KaufClever-bottom">
          <div className="KaufClever-bottom-item">
            <Image
              src={carIconYellow}
              className="KaufClever-bottom-image"
              alt="auto icon"
            />

            <h3>Täglich neue Fahrzeuge</h3>

            <p>
              Greife auf die größte Auswahl an Privatfahrzeugen zu. Intelligente
              Filter helfen dir, das Richtige zu finden.
            </p>
          </div>
          <div className="KaufClever-bottom-item">
            <Image
              src={checkmarkYellow}
              className="KaufClever-bottom-image"
              alt="kamera icon"
            />

            <h3>Kaufe mit Vertrauen</h3>

            <p>
              Jedes Fahrzeug hat detaillierte Beschreibungen, hochwertige Bilder
              und verifizierte Verkäufer – so weißt du genau, worauf du bietest.
              Kein Rätselraten.
            </p>
          </div>
          <div className="KaufClever-bottom-item">
            <Image
              src={glitterYellow}
              className="KaufClever-bottom-image"
              alt="Nutzer icon"
            />

            <h3>Clever bieten, fair zahlen</h3>

            <p>
              Setze dein Maximalgebot, und unser Proxy-System erledigt die
              Arbeit – du zahlst nur 50€ mehr als das nächsthöhere Gebot, sobald
              der Mindestpreis erreicht ist.
            </p>
          </div>
          <div className="KaufClever-bottom-item">
            <Image
              src={checkmarkDoc}
              className="KaufClever-bottom-image"
              alt="Euro icon"
            />

            <h3>Sichere Zahlung</h3>

            <p>
              Bezahle erst bei der Abholung, nachdem du das Fahrzeug selbst
              geprüft hast. Lieferung gewünscht? Schon bald kannst du es direkt
              zu dir liefern lassen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KaufClever;
